<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
	import { cookieSet } from '@/common/cookie';
	import { messages } from '@/i18n';
	import { routeReload } from './router';
	export default {
		name: 'app',
		watch: {
			'$i18n.locale': 'init',
		},
		provide() {
			return {
				reload: this.reload,
			};
		},
		created() {
			this.init(this.$i18n.locale);
			// this.i18nHandle(this.$i18n.locale);
		},
		methods: {
			init(val, oldVal) {
				cookieSet('language', val);
				document.querySelector('html').setAttribute('lang', val);
				document.title = "Royalair";
				// 非登录页面，切换语言刷新页面
				if (this.$route.name !== 'login' && oldVal) {
					// routeReload();
					location.reload();
				}
			},
			i18nHandle(val, oldVal) {
				cookieSet('language', val);
				document.querySelector('html').setAttribute('lang', val);
				document.title = messages[val].brand.lg;
				// 非登录页面，切换语言刷新页面
				if (this.$route.name !== 'login' && oldVal) {
					// routeReload();
					location.reload();
				}
			},
			reload() {
				this.isReloadAlive = false;
				this.$nextTick(function() {
					this.isReloadAlive = true;
				});
			},
		},
	};
</script>

<style lang="scss">
	@import '~@/assets/style/public-class.scss';

	* {
		font-family: 'Helvetica Neue', 'Helvetica', 'pingFang sc', 'Hiragino Sans GBMicrosoft YaHei', '微软雅黑Arial', sans-serif;
	}
	.el-table thead .cell {
		font-weight: 200 !important;
		color: #000 !important;
	}
	.el-pagination {
		margin-top: 20px;
	}
	.table-cell-content {
	  white-space: pre-wrap;
	  white-space: -moz-pre-wrap;
	  white-space: -o-pre-wrap;
	  word-wrap: break-word;
	  word-break: break-all;
	}
</style>
